import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { isEmpty } from 'lodash';
import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Input,
    FormHelperText
} from '@material-ui/core';
import extensionsSchema from '../../schemas/usersSchema';
import styles from './users.module.scss';

/**
 * Form used to describe how many users will be generated
 */
export default class Users extends Component {
    constructor(props) {
        super(props);

        this.form = React.createRef();
    }

    componentDidMount() {
        if (!this.form.current.state.values.AbleToComplete) {
            this.form.current.state.values.AbleToComplete = true;

            this.props.updateStep(this.form.current.state.values);
        } else if (this.props.editable) {
            this.form.current.submitForm();
        }
    }

    componentWillUnmount() {
        if (this.props.editable) {
            this.form.current.state.values.Completed = (this.form.current.state.values.InitialValid)
                ? true
                : isEmpty(this.form.current.state.errors) &&
                !isEmpty(this.form.current.state.touched);

            this.form.current.state.values.InitialValid = false;

            this.props.updateStep(this.form.current.state.values);
        }
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.fieldsContainer}>
                    <Formik
                        ref={this.form}
                        initialValues={{
                            Key: this.props.formData.key,
                            Completed: this.props.formData.Completed,
                            AbleToComplete: this.props.formData.AbleToComplete,
                            InitialValid: this.props.formData.InitialValid,
                            From: this.props.formData.From,
                            Qtty: this.props.formData.Qtty,
                            Random: this.props.formData.Random,
                            Password: this.props.formData.Password,
                            RepeatedPassword: this.props.formData.RepeatedPassword
                        }}
                        enableReinitialize={true}
                        validationSchema={extensionsSchema}
                        onSubmit={() => null}
                        render={(props) => (
                            <Form>
                                <div className={styles.row}>
                                    <TextField
                                        type="number"
                                        inputProps={{
                                            min: 100,
                                            max: 1000
                                        }}
                                        label={this.props.t('common:START')}
                                        name="From"
                                        value={props.values.From}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.From &&
                                            Boolean(props.errors.From)
                                        }
                                        helperText={
                                            (
                                                props.touched.From &&
                                                Boolean(props.errors.From)
                                            )
                                                ? <span>{this.props.t('validations:BETWEEN_100_1000')}</span>
                                                : <span>{this.props.t('validations:BETWEEN_100_1000')}</span>
                                        }
                                    />
                                    <TextField
                                        type="number"
                                        inputProps={{
                                            min: 1,
                                            max: 100
                                        }}
                                        label={this.props.t('common:QTTY')}
                                        name="Qtty"
                                        value={props.values.Qtty}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.Qtty &&
                                            Boolean(props.errors.Qtty)
                                        }
                                        helperText={
                                            (
                                                props.touched.Qtty &&
                                                Boolean(props.errors.Qtty)
                                            )
                                                ? <span>{this.props.t('validations:BETWEEN_1_100')}</span>
                                                : <span>{this.props.t('validations:BETWEEN_1_100')}</span>
                                        }
                                    />
                                </div>
                                <div className={styles.row}>
                                    <FormControl
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.Random &&
                                            Boolean(props.errors.Random)
                                        }
                                    >
                                        <InputLabel htmlFor="Random">{this.props.t('common:METHOD')}</InputLabel>
                                        <Select
                                            value={props.values.Random}
                                            onChange={event => {
                                                props.values.Password = '';
                                                props.values.RepeatedPassword = '';
                                                props.touched.Password = false;
                                                props.touched.RepeatedPassword = false;

                                                props.handleChange(event);
                                            }}
                                            onBlur={event => {
                                                props.values.Password = '';
                                                props.touched.Password = false;

                                                props.handleBlur(event);
                                            }}
                                            input={<Input name="Random" id="Random" />}
                                        >
                                            <MenuItem value={1}>{this.props.t('common:RANDOM')}</MenuItem>
                                            <MenuItem value={0}>{this.props.t('common:CUSTOM')}</MenuItem>
                                        </Select>
                                        <FormHelperText>
                                            {this.props.t('wizard:USERS_METHOD')}
                                        </FormHelperText>
                                    </FormControl>
                                </div>
                                {
                                    props.values.Random === 0 &&
                                    <div className={styles.passwordRow}>
                                        <TextField
                                            type="password"
                                            label={this.props.t('common:PASSWORD')}
                                            name="Password"
                                            value={props.values.Password}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            className={styles.field}
                                            disabled={!this.props.editable}
                                            error={
                                                props.touched.Password &&
                                                Boolean(props.errors.Password)
                                            }
                                            helperText={
                                                (
                                                    props.touched.Password &&
                                                    Boolean(props.errors.Password)
                                                )
                                                    ? <span>{this.props.t('validations:VALID_PASSWORD')}</span>
                                                    : <span>{this.props.t('validations:VALID_PASSWORD')}</span>
                                            }
                                        />
                                        <TextField
                                            type="password"
                                            label={this.props.t('common:REPEATED_PASSWORD')}
                                            name="RepeatedPassword"
                                            value={props.values.RepeatedPassword}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            className={styles.field}
                                            disabled={!this.props.editable}
                                            error={
                                                props.touched.RepeatedPassword &&
                                                Boolean(props.errors.RepeatedPassword)
                                            }
                                            helperText={
                                                (
                                                    props.touched.RepeatedPassword &&
                                                    Boolean(props.errors.RepeatedPassword)
                                                )
                                                    ? <span>{this.props.t('validations:MATCH_PASSWORD')}</span>
                                                    : ''
                                            }
                                        />
                                    </div>
                                }
                            </Form>
                        )}
                    />
                </div>
            </div>
        );
    }
}
